/** The prototype's line icons as one SVG sprite, used with <Icon id="globe" />. */
import type { JSX } from 'react';

import { RESOURCE_GLYPHS } from '@core/glyphs';

const SYMBOLS: Record<string, string> = {
  globe:
    '<circle cx="12" cy="12" r="8.5"/><path d="M5 9.5c2.5 1.2 4.6.6 6.2-.6 1.6-1.2 3.6-1 5 .4M6.5 16.5c1.8-1.2 3.6-.9 5 .2 1.3 1 3.1 1.1 4.9.1"/>',
  walk: '<circle cx="12" cy="5" r="2"/><path d="M9.5 21l2-6.5L14 17v4M8 12l2.5-3.5h3L16 12M11.5 14.5l1-6"/>',
  sprout:
    '<path d="M12 21v-8"/><path d="M12 13c0-4 3-6.5 7-6.5 0 4-3 6.5-7 6.5zM12 15c0-3.2-2.4-5.4-6-5.4 0 3.2 2.4 5.4 6 5.4z"/>',
  hand: '<path d="M8 13V6.5a1.5 1.5 0 0 1 3 0V12M11 11V5a1.5 1.5 0 0 1 3 0v6M14 11V6.5a1.5 1.5 0 0 1 3 0V14c0 4-2.5 6.5-6 6.5-2.6 0-4.2-1.3-5.5-3.5L4 14.2a1.4 1.4 0 0 1 2.3-1.6L8 14.5"/>',
  tree: '<path d="M12 21v-6"/><circle cx="12" cy="9.5" r="5.5"/>',
  people:
    '<circle cx="9" cy="8.5" r="3.2"/><path d="M3.5 19c.6-3.2 2.8-5 5.5-5s4.9 1.8 5.5 5"/><circle cx="16.5" cy="9.5" r="2.6"/><path d="M15.5 14.2c2.6-.3 4.5 1.3 5 4.3"/>',
  arrow: '<path d="M5 12h13M13 6l6 6-6 6"/>',
  chev: '<path d="M9 6l6 6-6 6"/>',
  back: '<path d="M15 6l-6 6 6 6"/>',
  check: '<path d="M5.5 12.5l4 4 9-9"/>',
  play: '<path d="M8 5.5v13l10.5-6.5z"/>',
  pause: '<path d="M8 5.5v13M16 5.5v13"/>',
  hill: '<path d="M2.5 19c2.6-6.3 5.3-9.5 8-9.5 1.5 0 2.6.9 3.6 2.2 1-1.1 2-1.7 3-1.7 2 0 3.8 3 4.4 9"/>',
  shovel:
    '<path d="M14.5 3.5l6 6M17.5 6.5L10 14M6.4 12.6l5 5-2.6 2.6a2.6 2.6 0 0 1-3.7 0l-1.3-1.3a2.6 2.6 0 0 1 0-3.7z"/>',
  up: '<path d="M12 19V5M6 11l6-6 6 6"/>',
  water:
    '<path d="M3.5 9.5c2.8-2 5.7-2 8.5 0s5.7 2 8.5 0M3.5 14.5c2.8-2 5.7-2 8.5 0s5.7 2 8.5 0"/>',
  x: '<path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/>',
  earth:
    '<path d="M3 18.5c2.5-3 5.6-4.5 9-4.5s6.5 1.5 9 4.5"/><path d="M12 14V8.5"/><path d="M12 9.5c0-2.7 1.9-4.5 4.6-4.5 0 2.7-1.9 4.5-4.6 4.5zM12 11c0-2.2-1.6-3.7-3.8-3.7 0 2.2 1.6 3.7 3.8 3.7z"/>',
  drop: '<path d="M12 3.5c3 3.7 5.5 7 5.5 10a5.5 5.5 0 0 1-11 0c0-3 2.5-6.3 5.5-10z"/>',
  stone:
    '<path d="M4 17.5c0-3.2 2.3-5.5 5.6-5.5 2.1 0 3.4.9 4.4 2.2.8-.7 1.8-1.1 3-1.1 2.3 0 3.5 1.8 3.5 4.4 0 .9-.6 1.5-1.5 1.5H5.3c-.8 0-1.3-.6-1.3-1.5z"/><path d="M9 8.5c.6-1.8 2-3 3.8-3 1.4 0 2.5.6 3.2 1.6"/>',
  hammer: '<path d="M14.5 4.5l5 5-2.5 2.5-5-5z"/><path d="M12.8 9.2L4.5 17.5l2 2 8.3-8.3"/>',
  info: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11v5.5M12 7.6v.4"/>',
  bars: '<path d="M6 19v-5M12 19V7M18 19v-9"/>',
  clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
  star: '<path d="M12 4.2l2.4 4.9 5.4.8-3.9 3.8.9 5.4L12 16.6l-4.8 2.5.9-5.4-3.9-3.8 5.4-.8z"/>',
};

export const LOGO =
  '<defs><radialGradient id="bm" cx="36%" cy="32%" r="72%"><stop offset="0" stop-color="#3B6893"/><stop offset=".6" stop-color="#21436B"/><stop offset="1" stop-color="#152D4C"/></radialGradient></defs><circle cx="16" cy="16" r="13.5" fill="url(#bm)"/><path d="M8.6 11.2c2.4-1.9 5.4-1.5 6.8.4 1.1 1.5 3.6 1.1 4.9 2.7 1.1 1.5-.2 3.5-2.1 3.8-2.1.3-2.5 2.6-4.2 3.6-1.7 1-4 .2-4.4-1.9-.3-1.7-2.4-2.5-2.7-4.4-.2-1.7.3-3.2 1.7-4.2z" fill="#CAC89C"/><path d="M20.5 21.6c1.2-.9 2.9-.7 3.4.5.4 1.1-.6 2.4-1.9 2.6-1.4.2-2.6-.4-2.6-1.4 0-.7.5-1.2 1.1-1.7z" fill="#A9C092"/>';

export function Icon({
  id,
  className = 'i',
}: {
  id: keyof typeof SYMBOLS;
  className?: string;
}): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: SYMBOLS[id] ?? '' }}
    />
  );
}

export function ResourceIcon({
  kind,
  className = 'ri',
}: {
  kind: string;
  className?: string;
}): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: RESOURCE_GLYPHS[kind] ?? '' }}
    />
  );
}

export function Logo({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: LOGO }}
    />
  );
}
